import { ref, type Ref, type CSSProperties } from 'vue'
import html2canvas from 'html2canvas'
import { format } from 'date-fns'

export type CaptureArgs = {
  clrBack?: string
  id?: string
}

export function getCaptureUtils(): {
  capt_inProgress: Ref<boolean>
  capt_contStyle: Ref<CSSProperties>
  capt_capture: ({ id, clrBack }: CaptureArgs) => void
} {
  const capt_inProgress = ref(false)
  const capt_contStyle = ref<CSSProperties>({})

  const capt_capture = ({ id = 'capture', clrBack = '#1e1e1e' }: CaptureArgs = {}) => {
    const captureCont = document.getElementById(id)
    if (!captureCont) {
      // eslint-disable-next-line no-console
      console.warn('No element to capture!!!')
      return
    }

    capt_inProgress.value = true
    captureCont.classList.add('capture-in-progress')

    let { width, height } = captureCont.getBoundingClientRect()
    const maxWidth = 21.5 * 16
    if (width > maxWidth) {
      width = maxWidth
    }
    capt_contStyle.value = {
      width: `${width}px`,
      maxWidth: `${width}px`,
      minWidth: `${width}px`,
      height: `${height}px`,
      maxHeight: `${height}px`,
      minHeight: `${height}px`,
      overflow: 'hidden',
    }
    setTimeout(() => {
      const opts = {
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
        backgroundColor: clrBack,
      }
      html2canvas(captureCont, opts).then(canvas => {
        const link = document.createElement('a')
        link.id = 'capturelink'

        link.target = '_blank'
        link.setAttribute('download', `GTOWizard_${format(new Date(), 'yyyy_MM_dd')}.png`)
        link.setAttribute(
          'href',
          canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'),
        )
        link.click()

        capt_inProgress.value = false
        capt_contStyle.value = {}

        if (captureCont) {
          captureCont.classList.remove('capture-in-progress')
        }
      })
    }, 222)
  }

  return {
    capt_inProgress,
    capt_contStyle,
    capt_capture,
  }
}
